import { ObjectModel, Product } from '@types';
import { modelBelongsToProduct } from './model-belongs-to-product';

export const findProductsByModel = (products: Product[], model: ObjectModel) =>
    products.filter(product => modelBelongsToProduct(product, model));
